import React from 'react';

// Components
import { WpText } from 'Wpds/components/text';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import WorkspaceDetailsListWrapper from '../WorkspaceSideRail/WorkspaceDetailsListWrapper';
import { WpDivider } from 'Wpds/components/divider';
import { WpButton } from 'Wpds/components/button';

// Constants
import ColorConstants from 'Wpds/colors/ColorConstants';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

// Styles
import './NoDesignAccessTipsComponent.scss';

const NoDesignAccessTipsComponent: React.FC = () => {
  const { intercomContactSalesEventName } = useApp();

  const baseClassName = 'NoDesignAccessTipsComponent';
  return (
    <div className={baseClassName}>
      <WpText bold>Get personalized team tips based on PI behavioral data.</WpText>
      <WpText>
        Add PI Design to your subscription, and learn how to lean into collective strengths and navigate potential
        cautions using science-powered behavioral data.
      </WpText>
      <div className={`${baseClassName}__cta`}>
        <WpButton dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>Connect with Sales</WpButton>
      </div>
      <WpText noMargin variant="bodySm">
        EXAMPLE
      </WpText>
      <div className={`${baseClassName}__example`}>
        <div className={`${baseClassName}__example__header`}>
          <div className={`${baseClassName}__example__header__title`}>
            <WpIllustration src={Illustrations['team_type_exploring']}></WpIllustration>
            <WpText bold noMargin>
              Exploring Team
            </WpText>
          </div>
          <WpText qaTest="teamShortDescription" variant="bodyXs" color="gray-600" noMargin>
            {'Daring  |  Risk-tolerant  |  Imaginative'}
          </WpText>
          <WpDivider padding={12}></WpDivider>
        </div>
        <WorkspaceDetailsListWrapper
          title="Team conversation tip"
          qaTest="noDesignTeamConversationTip"
          icon="lightbulb-on"
          iconColor={ColorConstants.blue[500]}
          list={['Take time to generate excitement around upcoming projects']}
        />
        <WorkspaceDetailsListWrapper
          title="Team reminder"
          qaTest="noDesignTeamReminder"
          icon="pause-circle"
          iconColor={ColorConstants.orange[500]}
          list={['Ensure the team aligns on attainable next steps when innovating']}
        />
      </div>
    </div>
  );
};

export default NoDesignAccessTipsComponent;
